// --- GLOBAL VARIABLES --- //
var $window        = $(window);
var $document      = $(document);
var $header        = $('.header');
var bp_small       = 770;
var bp_medium      = 992;
var class_active   = 'active';
var class_disabled = 'disabled';
var $this          = null;
var $containers    = $('html,body');


// --- COMPONENTS, PARTS --- //
$(document).ready(function () {
  // ---  COMPONENTS --- //
  fn_components_accordion();
  fn_components_countdown();
  fn_components_slider();
  fn_components_gallery();
  fn_components_select();
  fn_components_ajaxLoad();
  fn_components_tabs()
  fn_components_modal();
  fn_components_quantity_input();
  fn_components_remove();
  fn_components_checkboxSelect();
  fn_components_fullscreen_navigation();

  // Update
  fn_components_offer_calculation();
  fn_components_scroll();
  fn_components_rangeSlider();
  fn_components_searchProduct();

  // ---  PARTS --- //
  fn_parts_dropdown();
  fn_parts_show_hidden();

  fn_quantity_input_ajax_change();

});


// --- SCROLL EVENT --- //
$(document).scroll(function () {
});

// --- RESIZE EVENT --- //
$(window).resize(function () {
  // vypnuto 26.6.2018 na mobilu pri scrollovani v otevrenem menu pri dojeti nakonec menu se menu schovalo
  // fn_checkNavigationTrigger();
});

// --- LOAD EVENT --- //
$(window).bind('load', function () {
  fn_parts_dots();
});

//====================================================
//  Function: Accordion
//====================================================
function fn_components_accordion () {
    $(document).on('click', '.js-accordion-trigger', function () {
      console.log('fired');
      var inst       = $(this);
      var thisItem   = inst.closest('.js-accordion-item');
      var content    = '.js-accordion-content';
      var faqWrapper = inst.closest('.js-accordion-group')

      if (thisItem.hasClass('active')) {
        thisItem.toggleClass('active');
      } else {
        faqWrapper.find('.js-accordion-item.active').removeClass('active');
        inst.closest('.js-accordion-item').addClass('active');
      }
      $('.js-scroll').getNiceScroll().resize();

      return false;
    });

    $(document).bind('click', function (e) {
      // if (!$(e.target).is('.js-accordion-content')) {
      // 	if ($('.js-accordion-item.active').length){
      // 		$('.js-accordion-item.active').removeClass( 'active' );
      // 	}
      // }
    });
}

/* ==========================================================================
 *  Function: Ajax load
 * ======================================================================= */
function fn_components_ajaxLoad () {
  if ($('.js-load-more-content').length) {
    $('.js-load-more-content').bind('click', function () {
      var thisGrid = $(this).closest('.js-load-more-block');
      $.ajax({
        url:        'js/data/products.html',
        data:       'html',
        beforeSend: function () {
          thisGrid.find('.js-load-more').addClass('disabled');
          thisGrid.find('.js-load-more .loading-post').addClass(class_active);
        },
        success:    function (data) {
          setTimeout(function () {
            thisGrid.find('.js-load-more-grid').append(data);
            thisGrid.find('.js-load-more').removeClass('disabled')
            thisGrid.find('.js-load-more .loading-post').removeClass(class_active);
            // thisGrid.addClass( 'last' );
          }, 2000);
        },
        error:      function () {
          console.log('error');
        }
      });
    });
  }
}


//====================================================
//  Function: Checkbox select
//====================================================
function fn_components_checkboxSelect () {
  if ($('.js-radiobox-trigger').length) {
    $('.js-radiobox-trigger').on('change', function () {
      var inst          = $(this);
      var checkboxType  = inst.closest('.js-radiobox-block').data('checkbox-type');
      var checkboxValue = inst.closest('.js-radiobox-block').data('checkbox-value');
      var checkboxText  = inst.closest('.js-radiobox-block').data('checkbox-text');

      console.log(checkboxType);
      console.log(checkboxValue);
      console.log(checkboxText);

      if (checkboxType == 'payment') {
        $('.js-payment-text').text(checkboxText);
        $('.js-payment-value').text(checkboxValue);
      }

      if (checkboxType == 'transport') {
        $('.js-transport-text').text(checkboxText);
        $('.js-transport-value').text(checkboxValue);
      }
    });
  }
}

//====================================================
//  Function: Countdown
//====================================================
function fn_components_countdown () {
  if ($('.js-countdown').length) {

    // Generate date from today -> Comment or delete this lines
    var countDownEnd = new Date();
    countDownEnd     = new Date(countDownEnd.setMinutes(countDownEnd.getMinutes() + 10));

    // Uncomment this
    // Get date when countdown end from atribute
    // var countDownEnd = document.getElementsByClassName( 'js-countdown' )[0].getAttribute( 'data-countdown-end' );

    var countDownEndTimestamp, now;

    runTimer(countDownEnd);

    function runTimer (countDownEnd) {
      // init date for end countdown and get in Timestamp
      countDownEndTimestamp = new Date(countDownEnd).getTime();

      // init date for today and get in Timestamp
      now = new Date().getTime();

      // if is past end timer
      if (now > countDownEndTimestamp) {
        return false;
      }

      countdownToEnd();
    }


    function countdownToEnd () {
      // Update the count down every 1 second
      var countdownToEnd = setInterval(function () {

        // Get todays date and time
        var now = new Date().getTime();

        // Find the distance between now an the count down date
        var timeToEnd = countDownEndTimestamp - now;


        if (timeToEnd < 0) {
          clearInterval(countdownToEnd);
          return false;
        }

        // Time calculations for hours, minutes and seconds
        var hours   = editTime(Math.floor((timeToEnd % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        var minutes = editTime(Math.floor((timeToEnd % (1000 * 60 * 60)) / (1000 * 60)));
        var seconds = editTime(Math.floor((timeToEnd % (1000 * 60)) / 1000));


        // Output the result in an element with id='demo'
        outputResultTime(hours, minutes, seconds);

      }, 1000);
    }

    // add string '0' before number 0-9
    function editTime (string) {
      if (string < 10) {
        string = '0' + string;
      }
      return string;
    }

    // output actual time
    function outputResultTime (hours, minutes, seconds) {
      document.getElementsByClassName('js-countdown-hours')[0].innerHTML   = hours;
      document.getElementsByClassName('js-countdown-minutes')[0].innerHTML = minutes;
      document.getElementsByClassName('js-countdown-seconds')[0].innerHTML = seconds;
    }

  }
}


//====================================================
//  Initialization Fullscreeen navigation
//====================================================
function fn_components_fullscreen_navigation () {
  if ($('.navigation').length) {
    $('.navigation-trigger').on('click', function (e) {
      $(this).closest('.navigation').toggleClass('is-collapse');
      $('body').toggleClass('overflow-hidden');
      $('html').toggleClass('menu-open');
      e.preventDefault();
    });
    fn_checkNavigationTrigger();
  }
}

function fn_checkNavigationTrigger () {
  (function ($) {
    if ($('.navigation').hasClass('is-collapse')) {
      $('.navigation').removeClass('is-collapse');
      $('body').removeClass('overflow-hidden');
      $('html').toggleClass('menu-open');
    }
  })(jQuery);
}

//====================================================
//  Function: Gallery
//====================================================
function fn_components_gallery () {
  if ($('.js-gallery-trigger').length) {
    $('.js-gallery-trigger').on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      $('.detail-gallery-main .js-gallery-item-zoomable').first().trigger('click');
    });
  }

  if ($('.js-gallery').length) {
    $('.js-gallery').lightGallery({
      selector: '.js-gallery-item',
      hash:     false,
      download:     false,
      autoplay:     false,
      fullScreen:     false,
      videojs: true,
      videojsOptions: {
        autoplay: false
      }
      // thumbnail: false
    })
  }
}

//====================================================
//  Function: Modal
//====================================================
function fn_components_modal () {
  if ($('.js-modal-trigger').length) {
    // open modal
    $('.js-modal-trigger').on('click', function () {
      var inst    = $(this);
      var modalId = inst.data('modal');
      $('.modal-block.active').removeClass(class_active);
      $('.modal-overlay').addClass(class_active);
      $('.modal-block[data-modal=' + modalId + ']').addClass(class_active);

      $('body').addClass('overflow-hidden');
      return false;
    });

    // close modal
    $('.js-close-modal').on('click', function () {
      $('.modal-overlay').removeClass(class_active);
      $('.modal-block.active').removeClass(class_active);
      $('body').removeClass('overflow-hidden');
      return false;
    });

    // close modal keypress key escape
    $(document).keydown(function (event) {
      if (event.keyCode == 27 && $('.modal-block').hasClass('active')) {
        $('.js-close-modal').trigger('click');
      }
    });

    // close modal on click outside from modal box
    // $(document).on('click', function(event) {
    // 	if (!$(event.target).closest( '.modal-body' ).length) {
    // 		$( '.js-close-modal' ).trigger( 'click' );
    // 	}
    // });

  }
	else{
        // close modal
        $( '.js-close-modal' ).on( 'click' , function(){
            $( '.modal-overlay' ).removeClass( class_active );
            $( '.modal-block.active' ).removeClass( class_active );
            $( 'body' ).removeClass( 'overflow-hidden' );
            return false;
        });
	}
}

/* ==========================================================================
 *  Function: Offer calculation
 * ======================================================================= */
function fn_components_offer_calculation () {
  if ($('#progress-bar-status').length) {
    var actualPrice = $('.js-free-price').data('free-price-actual');
    var totalPrice  = $('.js-free-price').data('free-price-total');

    var missingPrice = totalPrice - actualPrice;

    $('.js-free-price-missing').text(missingPrice);

    var progressBarStatus = (actualPrice * 100) / totalPrice;

    // $( '#progress-bar-status' ).css('width', progressBarStatus + '%');

    $('.progress-bar-status').animate({width: progressBarStatus + '%'}, 'slow');
  }
}

/* ==========================================================================
 *  Function: Quantity input
 * ======================================================================= */
function fn_components_quantity_input () {
  if ($('.js-quantity').length) {
    $('.js-quantity').each(function () {
      var inst         = $(this),
          input        = inst.find('.js-quantity-input'),
          quantityUp   = inst.find('.js-quantity-up'),
          quantityDown = inst.find('.js-quantity-down'),
          min          = input.attr('min'),
          max          = input.attr('max');

      quantityUp.off('click');
      quantityUp.on('click', function (e) {
        var oldValue = parseFloat(input.val());
        if (oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }
        inst.find('.js-quantity-input').val(newVal);
        inst.find('.js-quantity-input').trigger('change');
      });

      quantityDown.off('click');
      quantityDown.on('click', function () {
        var oldValue = parseFloat(input.val());
        if (oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }
        inst.find('.js-quantity-input').val(newVal);
        inst.find('.js-quantity-input').trigger('change');
      });
    });
  }
}

/* ==========================================================================
 *  Function: quantity input ajax change
 * ======================================================================= */

function fn_quantity_input_ajax_change(){
  $(document).on('change', '.js-change-count', function(e){
    var $target = $(e.target);
    var $count = $target.val();
    var $link = $target.data('change-count-link');
    if($link && $count){
    $.nette.ajax({
      url:  $link,
      data: {
        'count': $count
      }
      });
    }
  });
}

/* ==========================================================================
 *  Function: range_slider
 * ======================================================================= */
var rangeSlider;

function fn_components_rangeSlider () {
  if ($('.js-range-slider').length) {
    var $range = $('.js-range-slider');

    $range.ionRangeSlider({
      type:         'double',
      grid:         false,
      force_edges:  true,
      postfix:      ' Kč',
      hide_min_max: true,
      // hide_from_to: true,
      onChange:     function (data) {
        value = data.from;
      }
    });

    rangeSlider = $range.data('ionRangeSlider');
  }

}


//====================================================
//  Function: Remove product
//====================================================
function fn_components_remove () {
  if ($('.js-remove-trigger').length) {
    $('.js-remove-trigger').bind('click', function () {
      $(this).closest('.js-remove-block').remove();
      if ($('.header-basket-item').length == 0) {
        $('.header-basket-dropdown').addClass('empty');
      } else {
        $('.header-basket-dropdown').removeClass('empty');
      }
    });
  }
}


//====================================================
//  Function: Custom scrollbar
//====================================================
function fn_components_scroll () {
  if ($('.js-scroll').length) {
    $('.js-scroll').niceScroll({
      cursorcolor:        '#f5bf17',
      cursorwidth:        "6px",
      background:         '#f5f4f2',
      cursorborder:       "none",
      cursorborderradius: "5px",
      autohidemode:       false
    });
  }
}

/* ==========================================================================
 *  Function: Search product
 * ======================================================================= */
function fn_components_searchProduct () {
  if ($('.js-search-input').length) {
    $('.js-search-input').keyup(function () {
      var searchText = $(this).val();
      searchProduct(searchText);
    });

    $('.js-search-btn').bind('click', function () {
      var searchText = $(this).closest('.search-form').find('.js-search-input').val();
      searchProduct(searchText);
    });

    function searchProduct (searchText) {
      if (searchText.length > 0) {
        $('.search-form').addClass('active');
      } else {
        $('.search-form').removeClass('active');
      }
    }
  }
}

//====================================================
//  Function: Select
//====================================================
function fn_components_select () {
  if ($('.js-select').length) {
    $('.js-select').select2({
      minimumResultsForSearch: Infinity,
      placeholder:             function () {
        $(this).data('placeholder');
      }
    }).focus(function () {
      $(this).select2('open');
    });
  }
}

//====================================================
//  Function: Slider
//====================================================
function fn_components_slider () {
  fn_main_slider();
  fn_classic_slider();
  fn_detail_slider();
  fn_gallery_slider();
  fn_milestone_slider();
  fn_manufacturer_slider();
}

function fn_main_slider () {
  if ($('.js-slider-hero').length) {
    $('.js-slider-hero').slick({
      infinite:       true,
      dots:           true,
      slidesToShow:   1,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       true,
      autoplaySpeed:  5000,
      // asNavFor: '.js-slider-hero-arrows' ,
      cssEase:        'ease-out',
      speed:          1500,
      variableWidth:  false,
      adaptiveHeight: false,
      nextArrow:      '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow:      '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
      mobileFirst:    true,
      /*
      dotsClass:      'custom_paging',
      customPaging:   function (slider, i) {
        //FYI just have a look at the object to find aviable information
        //press f12 to access the console
        //you could also debug or look in the source
        //console.log(slider);
        return (i + 1) + ' / ' + slider.slideCount;
      },
      */
      responsive:     [
        {
          breakpoint: 1220,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 990,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 770,
          settings:   {
            speed: 800,
            dots:  true,
          }
        },
        {
          breakpoint: 575,
          settings:   {
            speed: 600,
            dots:  true,
          }
        },
        {
          breakpoint: 250,
          settings:   {
            speed: 500,
            dots:  true,
          }
        }
      ]
    });

    // $( '.js-slider-hero-arrows' ).slick({
    // 	infinite: true,
    // 	dots: false,
    // 	slidesToShow: 1,
    // 	slidesToScroll: 1,
    // 	arrows: true,
    // 	autoplay: false,
    // 	autoplaySpeed: 5000,
    // 	cssEase: 'linear',
    // 	speed: 500,
    // 	asNavFor: '.js-slider-hero' ,
    // 	fade: true,
    // 	variableWidth: false,
    // 	nextArrow: '<span class="slick-arrows long-arrows slick-next"><i class="icon icon-sipka-dlouha-l"></i></span>',
    // 	prevArrow: '<span class="slick-arrows long-arrows slick-prev"><i class="icon icon-sipka-dlouha-p"></i></span>',
    // 	mobileFirst: true
    // });

    // $( '.js-slider-hero-text' ).slick({
    // 	infinite: false,
    // 	dots: false,
    // 	slidesToShow: 1,
    // 	slidesToScroll: 1,
    // 	arrows: false,
    // 	autoplay: false,
    // 	autoplaySpeed: 5000,
    // 	cssEase: 'linear',
    // 	speed: 500,
    // 	asNavFor: '.js-slider-hero' ,
    // 	fade: true,
    // 	variableWidth: false,
    // 	mobileFirst: true,
    // 	responsive: [
    // 		{
    // 			breakpoint: 1220,
    // 			settings: {
    // 				dots: false,
    // 			}
    // 		},
    // 		{
    // 			breakpoint: 990,
    // 			settings: {
    // 				dots: false,
    // 			}
    // 		},
    // 		{
    // 			breakpoint: 770,
    // 			settings: {
    // 				dots: false,
    // 			}
    // 		},
    // 		{
    // 			breakpoint: 575,
    // 			settings: {
    // 				dots: true,
    // 			}
    // 		},
    // 		{
    // 			breakpoint: 250,
    // 			settings: {
    // 				dots: true,
    // 			}
    // 		}
    // 	]
    // });
  }
}

function fn_manufacturer_slider () {
  if ($('.js-manufacturer-slider').length) {
    $('.js-manufacturer-slider').slick({
      infinite:       true,
      dots:           true,
      slidesToShow:   1,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       true,
      autoplaySpeed:  5000,
      // asNavFor: '.js-slider-hero-arrows' ,
      cssEase:        'ease-out',
      speed:          1500,
      variableWidth:  false,
      adaptiveHeight: false,
      nextArrow:      '<span class="slick-arrows slick-next"><i class="icon icon-right-arrow"></i></span>',
      prevArrow:      '<span class="slick-arrows slick-prev"><i class="icon icon-left-arrow"></i></span>',
      mobileFirst:    true,
      /*
      dotsClass:      'custom_paging',
      customPaging:   function (slider, i) {
        //FYI just have a look at the object to find aviable information
        //press f12 to access the console
        //you could also debug or look in the source
        //console.log(slider);
        return (i + 1) + ' / ' + slider.slideCount;
      },
      */
      responsive:     [
        {
          breakpoint: 1220,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 990,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 770,
          settings:   {
            speed: 800,
            dots:  true,
          }
        },
        {
          breakpoint: 575,
          settings:   {
            speed: 600,
            dots:  true,
          }
        },
        {
          breakpoint: 250,
          settings:   {
            speed: 500,
            dots:  true,
          }
        }
      ]
    });
  }
}

function fn_milestone_slider () {
  if ($('.js-slider-hero-milestone').length) {
    $('.js-slider-hero-milestone').slick({
      infinite:       true,
      dots:           true,
      slidesToShow:   1,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       true,
      autoplaySpeed:  5000,
      // asNavFor: '.js-slider-hero-arrows' ,
      cssEase:        'ease-out',
      speed:          1500,
      variableWidth:  false,
      adaptiveHeight: false,
      nextArrow:      '<span class="slick-arrows slick-next"><i class="icon icon-right-arrow"></i></span>',
      prevArrow:      '<span class="slick-arrows slick-prev"><i class="icon icon-left-arrow"></i></span>',
      mobileFirst:    true,
      customPaging: function(slider, i) {
        console.log($(slider.$slides[i]).attr('title'));
        return '<button class="tab"><span class="dot-title">' + $(slider.$slides[i]).attr('title') + '</span></button>';
      },
      /*
      dotsClass:      'custom_paging',
      customPaging:   function (slider, i) {
        //FYI just have a look at the object to find aviable information
        //press f12 to access the console
        //you could also debug or look in the source
        //console.log(slider);
        return (i + 1) + ' / ' + slider.slideCount;
      },
      */
      responsive:     [
        {
          breakpoint: 1220,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 990,
          settings:   {
            speed: 1000,
            dots:  true,
          }
        },
        {
          breakpoint: 770,
          settings:   {
            speed: 800,
            dots:  true,
          }
        },
        {
          breakpoint: 575,
          settings:   {
            speed: 600,
            dots:  true,
          }
        },
        {
          breakpoint: 250,
          settings:   {
            speed: 500,
            dots:  true,
          }
        }
      ]
    });
  }
}

function fn_gallery_slider () {
  if ($('.js-slider-gallery').length) {
    $('.js-slider-gallery').slick({
      infinite:       false,
      dots:           true,
      slidesToShow:   1,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       false,
      autoplaySpeed:  2000,
      cssEase:        'linear',
      draggable:      true,
      speed:          300,
      variableWidth:  false,
      mobileFirst:    true,
      nextArrow:      '<span class="slick-arrows slick-next"><i class="icon icon-right-arrow"></i></span>',
      prevArrow:      '<span class="slick-arrows slick-prev"><i class="icon icon-left-arrow"></i></span>',
      responsive:     [
        {
          breakpoint: 1024,
          settings:   {
            slidesToShow:   4,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 800,
          settings:   {
            slidesToShow:   3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 500,
          settings:   {
            slidesToShow:   2,
            slidesToScroll: 1,
          }
        }
      ]
    });
  }
}


function fn_classic_slider () {
  if ($('.js-slider-classic').length) {
    $('.js-slider-classic').slick({
      infinite:       true,
      dots:           false,
      slidesToShow:   5,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       false,
      autoplaySpeed:  3000,
      cssEase:        'linear',
      speed:          500,
      variableWidth:  false,
      swipeToSlide:   true,
      mobileFirst:    true,
      responsive:     [
        {
          breakpoint: 1440,
          settings:   {
            slidesToShow:   5,
            slidesToScroll: 1,
            dots:           false,
          }
        },
        {
          breakpoint: 1200,
          settings:   {
            slidesToShow:   4,
            slidesToScroll: 1,
            dots:           false,
          }
        },
        {
          breakpoint: 992,
          settings:   {
            slidesToShow:   3,
            slidesToScroll: 1,
            dots:           false,
          }
        },
        {
          breakpoint: 770,
          settings:   {
            slidesToShow:   3,
            slidesToScroll: 1,
            dots:           false,
          }
        },
        {
          breakpoint: 575,
          settings:   {
            slidesToShow:   2,
            slidesToScroll: 1,
            dots:           false,
            arrows:         true
          }
        },
        {
          breakpoint: 470,
          settings:   {
            slidesToShow:   2,
            slidesToScroll: 1,
            dots:           false,
            arrows:         true
          }
        },
        {
          breakpoint: 370,
          settings:   {
            slidesToShow:   1,
            slidesToScroll: 1,
            dots:           false,
            arrows:         true
          }
        },
        {
          breakpoint: 250,
          settings:   {
            slidesToShow:   1,
            slidesToScroll: 1,
            dots:           false,
          }
        }
      ]
    });
  }
}


function fn_detail_slider () {
  if ($('.js-slider-main-product').length) {
    $('.js-slider-main-product').slick({
      draggable:      false,
      touchMove:      false,
      swipe:          false,
      swipeToSlide:   false,
      infinite:       true,
      dots:           false,
      slidesToShow:   1,
      slidesToScroll: 1,
      autoplay:       false,
      arrows:         false,
      autoplaySpeed:  2000,
      cssEase:        'linear',
      speed:          500,
      fade:           true,
      nextArrow:      '<span class="slick-arrows style-mobile slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow:      '<span class="slick-arrows style-mobile slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
      variableWidth:  false,
      mobileFirst:    false,
        responsive:     [
            {
                breakpoint: 576,
                settings:   {
                    arrows: true,
                    dots: true
                }
            }
            ],
      asNavFor:       '.js-slider-thumbnail-product'
    });
  }

  if ($('.js-slider-thumbnail-product').length) {
    $('.js-slider-thumbnail-product').slick({
      infinite:       false,
      dots:           false,
      slidesToShow:   4,
      slidesToScroll: 1,
      arrows:         true,
      autoplay:       false,
      autoplaySpeed:  2000,
      cssEase:        'linear',
      speed:          500,
      asNavFor:       '.js-slider-main-product',
      focusOnSelect:  true,
      variableWidth:  false,
      mobileFirst:    true,
        responsive:     [
            {
                breakpoint: 319,
                settings:   {
                    slidesToShow:   3,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 575,
                settings:   {
                    slidesToShow:   4,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 769,
                settings:   {
                    slidesToShow:   3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 991,
                settings:   {
                    slidesToShow:   4,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
            {
                breakpoint: 1199,
                settings:   {
                    slidesToShow:   4,
                    slidesToScroll: 1,
                    arrows: false,
                }
            },
        ],
      nextArrow:      '<span class="slick-arrows style-1 slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
      prevArrow:      '<span class="slick-arrows style-1 slick-prev"><i class="icon icon-chevron-thin-left"></i></span>'
    });
  }
}


//====================================================
//  Function: Tabs
//====================================================
function fn_components_tabs () {
  if ($('.js-tabs-group').length) {
    $('.js-tabs-group .js-tabs-list-item').click(function () {
      var inst     = $(this);
      var thisId   = inst.attr('id');
      var thisTabs = $(this).closest('.js-tabs-group');

      if (thisId == 'undefined') {
        return false;
      }

      if (!inst.hasClass(class_active)) {
        thisTabs.find('.js-tabs-list-item.active').removeClass(class_active);
        $(this).closest('.js-tabs-list-item').addClass(class_active);
        thisTabs.find('.js-tabs-content .js-tabs-content-item.active').removeClass(class_active);
        thisTabs.find('.js-tabs-content .js-tabs-content-item[data-id="' + thisId + '"]').addClass(class_active);
      }
    });
  }
}


//====================================================
//  Function: Dots
//====================================================
function fn_parts_dots () {
  if ($('.dots').length) {
    fn_dots('.dots');
  }
}

function fn_dots (elem) {
  $(elem).each(function () {
    $(this).dotdotdot({'watch': true});
  });
}


/* ==========================================================================
 *  Function: Dropdown
 * ======================================================================= */
function fn_parts_dropdown () {
  if ($('.js-dropdown-trigger').length && $(window).width() < bp_small) {
    $('.js-dropdown-trigger').on('click', function () {
      $(this).closest('.js-dropdown-block').toggleClass(class_active);
    });
  }

  // if ($( '.js-hover-dropdown' ).length && $(window).width() > bp_small){
  // 	var $dropdowns = $('.js-hover-dropdown');

  //     $dropdowns.on("mouseenter", function() {
  //            $( '.modal-overlay' ).addClass('active');
  //     }).on("mouseleave", function() {
  //            $( '.modal-overlay' ).removeClass('active');
  //     });
  // }
}

//====================================================
//  Function: Show/hidden
//====================================================
function fn_parts_show_hidden () {
  if ($('.js-active-class-toggle').length) {
    $('.js-active-class-toggle').bind('click', function () {
      $(this).closest('.js-hidden-block').toggleClass('active').find('.js-hidden-content, .js-hidden-content-mobile, .js-hidden-content-tablet').toggleClass('active');
      $('.js-scroll').getNiceScroll().resize();
    });
  }
  if ($( '.js-active-class-toggle-trigger' ).length){
    $( '.js-active-class-toggle-trigger' ).bind( 'click' , function() {
      $(this).closest( '.js-active-block' ).toggleClass( class_active ).find( '.js-hidden-content' ).toggleClass( class_active );
      if ($(this).hasClass( 'header-icon' )){
        $( '#search-input' ).focus();
      }
    });
  }

  if ($( '.js-active-class-trigger' ).length){
    $( '.js-active-class-trigger' ).bind( 'click' , function() {
      $(this).closest( '.js-active-block' ).find( '.js-hidden-content' ).addClass( class_active );
    });
  }

  if ($( '.js-remove-class-trigger' ).length){
    $( '.js-remove-class-trigger' ).bind( 'click' , function() {
      $(this).closest( '.js-remove-block' ).find( '.js-hidden-content' ).removeClass( class_active );
    });
  }

  if ($( '.js-hidden-trigger' ).length){
    $( '.js-hidden-trigger' ).bind( 'click' , function() {
      $(this).hide();
      $(this).closest( '.js-hidden-block' ).find( '.js-hidden-content' ).addClass( class_active );
    });
  }
}


//# sourceMappingURL=app.js.map
